import { render, staticRenderFns } from "./minrent.vue?vue&type=template&id=2d886e1c&scoped=true&"
import script from "./minrent.vue?vue&type=script&lang=js&"
export * from "./minrent.vue?vue&type=script&lang=js&"
import style0 from "./minrent.vue?vue&type=style&index=0&id=2d886e1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d886e1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d886e1c')) {
      api.createRecord('2d886e1c', component.options)
    } else {
      api.reload('2d886e1c', component.options)
    }
    module.hot.accept("./minrent.vue?vue&type=template&id=2d886e1c&scoped=true&", function () {
      api.rerender('2d886e1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2YZ7ZmAHAfl96/JS/comp/minrent.vue"
export default component.exports